import React from 'react';
import { ISearchInsteadProps, ISoldOutArticle } from '../searchresultpage.d';
import classNames from 'classnames';
import FragmentPlaceholder from '../../../Common/fragment-placeholder/fragment-placeholder';
import styles from './searchbox.scss';

const SearchInsteadInfo = (props: ISearchInsteadProps) => {
    const showTopSearchbox =
        props.topPageSearchBoxFragment != null ||
        props.htmlEncodedAppropriateResultNotFoundText != '' ||
        props.soldOutArticles?.length > 0;
    const showSingleAltHeadline =
        props.htmlEncodedAppropriateResultNotFoundText != '' ||
        props.htmlEncodedSearchInsteadText != '';

    const getHtmlEncodedText = () => {
        let htmlEncodedText = '';
        if (props.htmlEncodedAppropriateResultNotFoundText) {
            htmlEncodedText = props.htmlEncodedAppropriateResultNotFoundText;
        }
        if (props.htmlEncodedSearchInsteadText) {
            htmlEncodedText += ' ' + props.htmlEncodedSearchInsteadText;
        }
        return htmlEncodedText;
    };

    const getTextElement = (htmlEncodedText: string) => {
        return (
            <div className={styles.headline}
                dangerouslySetInnerHTML={{ __html: htmlEncodedText }}>
            </div>
        );
    };

    const getSoldOutArticleInfo = (article: ISoldOutArticle) => {
        const articleInfo =
            props.l10n.startQuotationMark +
            article.articleName +
            props.l10n.endQuotationMark +
            ' - ' +
            props.l10n.catalogNoLesserAcronym +
            props.l10n.colon +
            ' ' +
            article.salesArticleNo;
        return articleInfo;
    };

    return props.style === 'single-alternative-search-result' ? (
        showSingleAltHeadline ? (
            <div className={classNames(styles.search_instead_info, props.style)}>
                {getTextElement(getHtmlEncodedText())}
            </div>
        ) : <></>
    ) : (
        <>
            {showTopSearchbox && (
                <div className={classNames(styles.search_box_fragment, 'top', `fas_${props.style}`)}>
                    {props.htmlEncodedAppropriateResultNotFoundText &&
                        getTextElement(props.htmlEncodedAppropriateResultNotFoundText)}

                    {props.soldOutArticles?.length > 0 && (
                        <div className={styles.search_result_sold_out}>
                            <span className={styles.sold_out_info}>
                                {props.l10n.alreadySoldOut}
                            </span>
                            {props.soldOutArticles.map((article, index) => {
                                return (
                                    <span
                                        key={index}
                                        className={styles.sold_out_article_info}
                                        dangerouslySetInnerHTML={{ __html: getSoldOutArticleInfo(article) }}>
                                    </span>
                                );
                            })}
                        </div>
                    )}

                    {props.topPageSearchBoxFragment != null && (
                        <FragmentPlaceholder
                            src={props.topPageSearchBoxFragment.source}
                            ignoreErrors={true}
                            fallbackSrc={props.topPageSearchBoxFragment.fallbackSource}
                        />
                    )}
                </div>
            )}
            
            {/* description for teaser view page */}
            {props.htmlEncodedSearchInsteadText && (
                <div className={classNames(styles.search_instead_info, props.style)}>
                    {getTextElement(props.htmlEncodedSearchInsteadText)}
                </div>
            )}
        </>
    );
};

export default SearchInsteadInfo;
